import { IMiningPlanOptions } from "@services/getMinerList";
import { RootState } from "@store";
import { ALLOW_WEEKDAY_PLANS } from "../../config";
import { useSelector } from "react-redux";

export const useMiningPlans = (): IMiningPlanOptions[] => {
  const plans = useSelector(
    (state: RootState) => state.miningPlans.mining_plans
  );
  if (!plans) return [];
  if (!ALLOW_WEEKDAY_PLANS) {
    for (let i = 0; i < plans.length; i++) {
      plans[i].schedule = plans[i].schedule.filter(sch => sch.day.length === "DD/MM/YYYY".length)
    }
  }
  return !!plans ? plans : [];
};

export const useMiningPlansNames = (): string[] => {
  const plans = useMiningPlans();

  const arr: string[] = [];

  plans?.map((plan) => arr.push(plan.name));
  return arr;
};
